import React from 'react';
import { theme } from '../theme';
import { feeLabel } from '../utils/fee';

// PurchaseSuccessModal — new (Sep 3, per Ali's report). A real
// explanatory confirmation step after a successful charge, for both
// purchase types this app has. Before this, a Price Freeze success
// went straight to navigation with no confirmation shown at all, and
// a pin-bundle success only got a small toast — neither explained
// what the charge actually meant. Styled to match the app's real
// theme exactly (navy/white/gold, sharp corners, JetBrains Mono for
// the price), not a generic modal look.
//
// type: 'freeze' | 'pins'. onDismiss fires when "Got it" is clicked —
// the caller decides what happens next (navigate to the freeze detail
// page, or just close and stay put for a pin purchase), since that
// differs by purchase type and even by which screen triggered it.
//
// feeAmount/durationLabel (Sep 9, per Ali's report — real bug, caught
// via a deliberate duration-tier sweep, not a live screenshot this
// time): this component hardcoded "$9.99... 5 days" for every freeze
// purchase regardless of which tier was actually bought — the exact
// same class of bug already fixed elsewhere, just never caught here
// since this specific screen wasn't touched during that earlier pass.
// Both required for type='freeze'; ignored for type='pins', which
// still correctly hardcodes $3.00 since that's a single, real, fixed
// price with no tiers to get wrong.
function PurchaseSuccessModal({ type, feeAmount, durationLabel, onDismiss }) {
  console.log('[DIAG] PurchaseSuccessModal mounted, type:', type);
  const feeText = feeLabel(feeAmount);
  const duration = durationLabel || 'the watch period';
  const content = type === 'freeze' ? {
    title: 'Price Watch started',
    body: `We'll check this fare every 2 hours for ${duration}. If the price ends US$5 or more above, or US$20 or more below, your starting price, you pay nothing. Otherwise the ${feeText} covers the watching.`,
    disclaimer: (
      <>
        Price Watch doesn't reserve the fare; it's about the {feeText} you pay for it. Our responsibility is limited to refunding this fee under our stated terms — see our{' '}
        <a href="https://flyatlast.com/terms.html" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>terms</a> for details.
      </>
    ),
  } : {
    title: '3 more pins added',
    body: "Your $3.00 charge added 3 more tracking slots to your account — track more trips at once, and buy more bundles anytime, no cap.",
    disclaimer: 'Pin bundle purchases are one-time charges and non-refundable once the slots have been applied to your account.',
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
    }}>
      <div style={{ background: '#fff', border: `2px solid ${theme.structural}`, borderRadius: '0px', maxWidth: '400px', width: '100%', padding: '28px 24px' }}>
        <p style={{ fontFamily: theme.fontDisplay, fontSize: '17px', fontWeight: 800, color: theme.textPrimary, marginBottom: '6px' }}>
          {content.title}
        </p>
        <p style={{ fontSize: '13px', color: theme.textMuted, marginBottom: '18px', lineHeight: 1.5 }}>
          {content.body}
        </p>
        <p style={{ fontSize: '12px', color: theme.textMuted, lineHeight: 1.5, marginBottom: '18px', borderTop: `1px solid ${theme.border}`, paddingTop: '14px' }}>
          {content.disclaimer}
        </p>
        <button
          onClick={onDismiss}
          style={{
            width: '100%', background: theme.action, color: '#1a1a1a', border: 'none',
            borderRadius: '0px', height: '44px', fontSize: '14px', fontWeight: 700,
            fontFamily: theme.fontDisplay, cursor: 'pointer'
          }}
        >
          Got it
        </button>
      </div>
    </div>
  );
}

export default PurchaseSuccessModal;